import React from 'react';
import { Box, Paper } from '@mui/material';
import { DataGrid, type DataGridProps } from '@mui/x-data-grid';
import { csCZ } from '@mui/x-data-grid/locales';

type AdminDataGridProps = DataGridProps & {
    minHeight?: number;
};

const AdminDataGrid: React.FC<AdminDataGridProps> = ({
    minHeight = 400,
    ...props
}) => {
    return (
        <Paper
            variant="outlined"
            sx={{
                width: '100%',
                overflow: 'hidden',
                '& .MuiDataGrid-root': {
                    border: 'none',
                },
            }}
        >
            <Box sx={{ minHeight, width: '100%' }}>
                <DataGrid
                    autoHeight
                    disableRowSelectionOnClick
                    pageSizeOptions={[10, 20, 25, 50]}
                    initialState={{
                        pagination: {
                            paginationModel: { pageSize: 20 },
                        },
                    }}
                    localeText={csCZ.components.MuiDataGrid.defaultProps.localeText}
                    {...props}
                    sx={{
                        '& .MuiDataGrid-columnHeaders': {
                            minHeight: '48px !important',
                        },
                        ...props.sx,
                    }}
                />
            </Box>
        </Paper>
    );
};

export default AdminDataGrid;
